import { FieldValues } from "react-hook-form";

import * as yup from "yup";

export const referenceSchema = yup.object<FieldValues>({
  Author: yup.string().required(),
  Title: yup.string().required(),
  Link: yup.string().nullable().url("Link must be a valid URL"),
});
